import cx from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { ReactComponent as StarIcon } from '../../assets/icons/star.svg';
import { getActiveExpert, getExpertsOnlineStatus, getExpertMode, getIsEmex } from '../../store/selectors';

import UserIcon from '../UserIcon/UserIcon';
import s from './index.module.css';

const ExpertInfo = ({ isPartreview, isMobile }) => {
  const expert = useSelector(getActiveExpert);
  const expertsOnlineStatus = useSelector(getExpertsOnlineStatus);
  const mode = useSelector(getExpertMode);
  const isEmex = useSelector(getIsEmex);
  const showFullExpertText = !isMobile;
  const isEmexMobile = isEmex && isMobile;

  const showExpertInfo = expert;
  // const showExpertInfo = mode === 'card' && expert;

  const numberRating = expert?.rating;
  const numberRatingEmex = numberRating && Math.round(numberRating * 10) / 10;
  const displayedRating = numberRating?.toString().replace('.', ',');
  const displayedRatingEmex = numberRatingEmex?.toString().replace('.', ',');
  const isOnline = expertsOnlineStatus && expert &&
    expertsOnlineStatus.filter(t => t.expertId === expert.expertId)[0]?.isOnline;

  return (
    showExpertInfo && (
      <div className={cx(s.wrapper, {
        [s.partReviewExpertWrapper]: isPartreview,
        [s.mobileEmexExpertWrapper]: isEmexMobile
      })}>
        {expert.photoPath && (
          <div className={s.avatarWrapper}>
            <UserIcon isOnline={isOnline} icon={expert.photoPath} />
          </div>
        )}
        <div className={cx(s.expertInfo, { [s.mobileEmexExpertInfo]: isEmexMobile })}>
          {expert.name &&
            <span className={cx(s.expertName, { [s.mobileEmexExpertName]: isEmexMobile })}>
              {expert.name}
            </span>
          }
          {displayedRating && (
            <div className={s.rating}>
              {showFullExpertText && <span className={s.ratingText}>Рейтинг эксперта</span>}
              <StarIcon className={s.ratingImage} />
              <span>{displayedRatingEmex}</span>
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default ExpertInfo;
